/*
 * Collapser: to expand and collapse target elements like an accordion
 *
 * Usage:
 * Specifying data-parent will group the collapse
 * elements appropriately into an accordion, and will
 * hide any other previously open elements in that group
 *
 * <i class="icon js-collapser-toggle" data-parent="#mobile-menu" data-target="#target"></i>
 * <div class="is-collapsed" id="target" aria-expanded="false"></div>
**/

var Collapser = {

	config: {
		expandClass       : 'is-expanded',
		targetExpandClass : 'target-expanded',
		targetClass 			: 'is-open',
	},

	expand: function(target, parent) {
		var targetString = target.replace("#", "");

		$(parent).find('.' + Collapser.config.expandClass).removeClass(Collapser.config.expandClass);
		$(parent).find('.' + Collapser.config.targetClass).removeClass(Collapser.config.targetClass);

		$(target).addClass(Collapser.config.expandClass);
		$(target).attr('aria-expanded', 'true');
		$('#mobile-nav-item-' + targetString).addClass(Collapser.config.targetClass);

	},

	collapse: function(target, parent) {
		var targetString = target.replace("#", "");

		$(target).removeClass(Collapser.config.expandClass);
		$(target).attr('aria-expanded', 'false');
		$('#mobile-nav-item-' + targetString).removeClass(Collapser.config.targetClass);

	},

	init: function(className) {

		$(className).on('click', function(){

			var target = $(this).attr('data-target'),
				parent = $(this).attr('data-parent');

			if ( $(target).hasClass(Collapser.config.expandClass) ) {

				$(this).removeClass(Collapser.config.targetExpandClass);
				Collapser.collapse(target, parent);

			} else {
				$(parent).find('.' + Collapser.config.targetExpandClass).removeClass(Collapser.config.targetExpandClass);

				$(this).addClass(Collapser.config.targetExpandClass);
				Collapser.expand(target, parent);
			}
 		});
	},
}

module.exports = Collapser;



// WEBPACK FOOTER //
// ./assets/src/js/modules/collapser.js